import { render } from "./quiz2.vue?vue&type=template&id=3351921b&scoped=true"
import script from "./quiz2.vue?vue&type=script&lang=js"
export * from "./quiz2.vue?vue&type=script&lang=js"

import "./quiz2.vue?vue&type=style&index=0&id=3351921b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3351921b"]])

export default __exports__